export const environment = {
  production: false,
  transactionPollingDelay: 3500,
  transactionPollingTimeout: 120000,
  baseUrl: 'https://api.xpay.dev.veone.net'
};
